/**
 * Nazwy pól z `missingFields` po ludzku — te same, co w API
 * (`PRE_ORDER_FIELD_LABELS` w `pre-order/manual-entry.ts`) i na karcie
 * prezlecenia. Nieznana nazwa zostaje, jak przyszła.
 *
 * Wydzielone z `UserOfferShow.tsx` (15.10.2026), bo braki pokazuje też
 * baner prezlecenia w oknie zlecenia wg makiety FTL.
 */
export const MISSING_FIELD_LABELS: Record<string, string> = {
  companyId: 'spółka',
  clientName: 'klient',
  loadingCity: 'miasto załadunku',
  unloadingCity: 'miasto rozładunku',
  loadingDate: 'data załadunku',
  unloadingDate: 'data rozładunku',
};

export const missingFieldLabel = (field: string): string => MISSING_FIELD_LABELS[field] ?? field;
